import { render, staticRenderFns } from "./UpgradeInterestModal.vue?vue&type=template&id=4735ed2c&scoped=true&"
import script from "./UpgradeInterestModal.vue?vue&type=script&lang=ts&"
export * from "./UpgradeInterestModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpgradeInterestModal.vue?vue&type=style&index=0&id=4735ed2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4735ed2c",
  null
  
)

export default component.exports